module.exports = __webpack_public_path__ + "static/img/ios_ha.2e01e9d0.png";